/**
 * SuspendedNotice — mesajul afisat userului banat cand intra pe /upload
 * sau incearca sa comente. Spune clar:
 *   "Contul tau a fost suspendat temporar. Discuta cu mirele/mireasa."
 *
 * GalleryPage nu afiseaza asta (poate vedea in continuare pozele).
 */

import { motion } from 'framer-motion';

export function SuspendedNotice({ reason }: { reason: string | null }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className="w-full max-w-md rounded-lg border border-error/40 bg-error/10 p-lg text-center shadow-md"
      role="alert"
    >
      <div className="mx-auto mb-md flex h-12 w-12 items-center justify-center rounded-full bg-error/20 text-2xl text-error">
        ⏸
      </div>
      <h2 className="font-serif text-h3 text-fg">
        Cont suspendat temporar
      </h2>
      <p className="mt-sm text-sm text-fg-soft">
        Dreptul tău de a încărca poze și de a comenta a fost suspendat temporar.
      </p>
      <p className="mt-md text-sm font-medium text-fg">
        Te rugăm să discuți cu mirele sau mireasa pentru a rezolva această situație.
      </p>
      {reason && (
        <p className="mt-md text-xs italic text-fg-soft">
          Motiv (notă internă): {reason}
        </p>
      )}
    </motion.div>
  );
}